import type { AxiosResponse } from "axios";

import api from "../utils/AxiosInterceptor";

export async function getCategoriesProcess(
  tenantId?: string
): Promise<AxiosResponse> {
  const params = new URLSearchParams();

  if (tenantId) {
    params.append("tenant", tenantId);
  }

  const response = await api.get(
    "/api/v1/process-definitions/categories-process",
    {
      params,
    }
  );

  return response;
}
